// extracted by mini-css-extract-plugin
module.exports = {"story":"mosaic_story__2o86j","cover":"mosaic_cover__fmN6A","filter":"mosaic_filter__W_4HT","portrait":"mosaic_portrait__qhOUC"};